import { handleBlobResponse } from "../../custom/helpers/HandleResponse";
import http from "../core/http";
const group = 'raceKits';

export const getDataListRequest =  async (data) => {
    return await http.post(`${group}/get`, data).then(res => res.data).catch(http.defaultCatch);
}

export const isDisplayedRequest =  async (data) => {
    return await http.post(`${group}/isDisplayed`, data).then(res => res.data).catch(http.defaultCatch);
}

export const createDataRequest =  async (data) => {
    return await http.post(`${group}/create`, data).then(res => res.data).catch(http.defaultCatch);
}

export const updateDataRequest =  async (data) => {
    return await http.post(`${group}/update`, data).then(res => res.data).catch(http.defaultCatch);
}

export const resetDataRequest =  async (data) => {
    return await http.post(`${group}/reset`, data).then(res => res.data).catch(http.defaultCatch);
}

export const deleteDataRequest =  async (data) => {
    return await http.post(`${group}/delete`, data).then(res => res.data).catch(http.defaultCatch);
}

export const issueDataRequest =  async (data) => {
    return await http.post(`${group}/bibIssue`, data).then(res => res.data).catch(http.defaultCatch);
}
export const teeIssueDataRequest =  async (data) => {
    return await http.post(`${group}/teeIssue`, data).then(res => res.data).catch(http.defaultCatch);
}


export const getRaceListRequest =  async (data) => {
	return await http.post(`${group}/getRaceList`, data).then(res => res.data).catch(http.defaultCatch);
}
export const getTeeListRequest =  async (data) => {
	return await http.post(`${group}/getTeeList`, data).then(res => res.data).catch(http.defaultCatch);
}

export const getNationalityListRequest =  async (data) => {
	return await http.post(`${group}/getNationalityList`, data).then(res => res.data).catch(http.defaultCatch);
}

export const exportDataListRequest =  async (data) => {
    const response = await http({url: `${group}/export`, method: "POST", data: data, responseType: "blob"}).then(res => res.data).catch(http.defaultCatch);
    handleBlobResponse(response, (data?.DownloadName || 'Kit-Report.xlsx'));
}

export const exportClubKitsRequest = async (data) => {
    // The filename is built here rather than taken from the response: only
    // res.data survives the interceptor, so Content-Disposition never reaches
    // the browser. Mirrors the slug in RaceKitController@exportByClub, which
    // still names the file correctly for anything calling the API directly.
    const slug = String(data?.Club || '').replace(/[^A-Za-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
    const response = await http({url: `${group}/exportByClub`, method: "POST", data: data, responseType: "blob"}).then(res => res.data).catch(http.defaultCatch);
    handleBlobResponse(response, (data?.DownloadName || `kit-report-${slug !== '' ? slug : 'club'}.xlsx`));
}

export const setBibTagRequest = async (data) => {
    return await http.post(`${group}/setBibTag`, data).then(res => res.data).catch(http.defaultCatch);
}

export const setGoalRequest = async (data) => {
    return await http.post(`${group}/setGoal`, data).then(res => res.data).catch(http.defaultCatch);
}

export const getClubsForActiveEventRequest = async () => {
    return await http.post(`${group}/getClubsForActiveEvent`).then(res => res.data).catch(http.defaultCatch);
}

export const bulkIssueByClubRequest = async (data) => {
    return await http.post(`${group}/bulkIssueByClub`, data).then(res => res.data).catch(http.defaultCatch);
}

export const getRaceKitsByClubRequest = async (data) => {
    return await http.post(`${group}/getRaceKitsByClub`, data).then(res => res.data).catch(http.defaultCatch);
}

export const importDataRequest =  async (data) => {
    return await http.post(`raceKitImport/import`, data).then(res => res.data).catch(http.defaultCatch);
}

export const searchRaceKitsByIDRequest =  async (data) => {
    return await http.post(`${group}/searchByID`, data).then(res => res.data).catch(http.defaultCatch);
}